import { Base } from '@studiometa/js-toolkit';
import { Panel } from '@studiometa/ui';
import 'liquid-ajax-cart';
import Header from './Header.js';
import Navbar from './Navbar/index.js';
import Cart from '../molecules/Cart/index.js';
import Search from './Search/index.js';
import Facets from './Facets/index.js';
import ProductStickyBar from '../atoms/ProductStickyBar.js';
import ProductInfo from './ProductInfo.js';
import Blog from '../organisms/Blog/index.js';

/**
 * Shop component
 */
export default class Shop extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Shop',
    components: {
      Header,
      Navbar,
      Cart,
      Blog,
      Search,
      Facets,
      ProductStickyBar,
      ProductInfo,
      Panel,
    },
  };
}
